export default __webpack_public_path__ + "static/chicken-korma-and-rice-243a04aa664dce4d2f6145278d4c84f1.jpg";